import axios from '@/plugins/axios'
export const estico = {
  async getEsticoInformationByToken (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('pay/' + payload)
        .then((response) => {
          resolve(response.data)
          context.commit('LOADER')
          context.commit('setEsticoInfo', response.data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  async initCheckoutSession (context, payload) {

  },
  async getAddressByCep (context, payload) {
    return new Promise((resolve, reject) => {
      axios.get('pay/cep/' + payload).then((response) => {
        context.commit('ADDRESS', response.data)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  },
  async CARDSAVE ({ commit }, payload) {
    commit('CARDSAVE', payload)
  },
  async payEstico (context, payload) {
    return new Promise((resolve, reject) => {
      const data = {
        customer: {
          ...context.getters.customer,
          senderHash: window.payment.senderHash
        },
        address: {
          ...context.getters.address
        },
        payment: {
          ...context.getters.payment
        },
        card: {
          ...context.getters.card
        }
      }
      axios.post('pay/' + payload, data).then((response) => {
        context.commit('LOADER')
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}
